import React from 'react'
import { css } from '@emotion/core'
import { colors, LayoutBand, Row, H1, H2, Card, Separator, Subheading, MarginBox, Paragraph } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'
import layoutBandBackground from '../assets/map.svg'
import useUserAdminRoleStatus, { USER_STATUS } from './ManagerPage/hooks/useUserAdminRoleStatus'

const layoutBandCss = css`
  background-image:
    linear-gradient(262.59deg, rgba(0, 128, 255, 0.5) -7.29%, rgba(85, 186, 211, 0.6) 106.06%),
    url(${layoutBandBackground});
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  position: relative;

  min-height: calc(100vh - 44px);
`

function AppCard({ overline, heading, subHeading, to }) {
  return (
    <Card backgroundColor={colors.gray02} to={to} maxWidth={400}>
      <Row alignX="center" gutters="none">
        <MarginBox marginX="sm">
          <Separator size="sm" />
          <Paragraph size="sm"> {overline}</Paragraph>
          <H2 size="H3" supplementary>
            {heading}
            <Subheading>{subHeading}</Subheading>
          </H2>
          <Separator size="md" />
        </MarginBox>
      </Row>
    </Card>
  )
}

export default function AdminLandingPage() {
  const [t] = useTranslation()
  const userStatus = useUserAdminRoleStatus()
  const isLearnToRankEnabled = useFeatureFlag('standards_authorities_admin_LTR')?.isOn

  if (userStatus === USER_STATUS.LOADING) {
    return null
  }

  return (
    <LayoutBand as="section" id="adminLandingPage" alignY="center" css={layoutBandCss} marginY="lg" marginX="xl">
      <Row gutters="xl" wrap>
        <MarginBox noShrinkX growX>
          <H1>
            Authorities
            <Subheading>Admin Tool</Subheading>
          </H1>
        </MarginBox>
        <Separator size="xxl" />
        <Row gutters="xxl" wrap>
          <AppCard
            growX
            overline="Place"
            heading="Reports"
            subHeading={t(
              'admin-landing-page.place-reports-app-card.sub-heading',
              'View Reports by Region and Country'
            )}
            to="./place-reports/"
          />
          {userStatus === USER_STATUS.SUPER_ADMIN && (
            <AppCard
              growX
              overline="Place"
              heading="System Manager"
              subHeading={t('admin-landing-page.place-manager-app-card.sub-heading', 'Manage Types and Groups')}
              to="./manager/"
            />
          )}
          {userStatus === USER_STATUS.SUPER_ADMIN && (
            <AppCard
              growX
              overline="Place"
              heading="Activity Monitor"
              subHeading={t('admin-landing-page.place-activity-app-card.sub-heading', 'View by User or Jurisdiction')}
              to="./monitor/"
            />
          )}
          {userStatus === USER_STATUS.SUPER_ADMIN && (
            <AppCard
              growX
              overline="Place"
              heading="Editor Handbook"
              subHeading={t(
                'admin-landing-page.place-editor-handbook-app-card.sub-heading',
                'Editor Guidelines & Training'
              )}
              to="./editor-handbook/"
            />
          )}
          {isLearnToRankEnabled && userStatus === USER_STATUS.SUPER_ADMIN && (
            <AppCard
              growX
              overline="Place"
              heading="Learn To Rank"
              subHeading={t('admin-landing-page.place-learn-to-rank-app-card.sub-heading', 'Learn to Rank Places')}
              to="./place-learn-to-rank/"
            />
          )}
        </Row>
      </Row>
    </LayoutBand>
  )
}
